import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
//import ReCAPTCHA from "react-google-recaptcha";

import CustomTextInput from './CustomTextInput';
import { CustomButton } from './CustomButton';
import CustomModal from './CustomModal';
import TextField from '@mui/material/TextField';

import { sendContactInfo } from '../services/contact';

import './ContactUsModal.css';

//const { REACT_APP_CAPTCHA_KEY } = process.env;

const ContactUsModal = ({ closeModal }) => {

    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [message, setMessage] = useState('');
    const [name, setName] = useState("");

    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    function verifyEmail(emailInput) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput);
    }

    /*function onChange(value) {
        console.log("Captcha value:", value);
    }*/

    async function submitForm() {

        setButtonDisabled(true);
        const status = await sendContactInfo(companyName, email, message, name);
        console.log("status", status)
        if (status !== 200) {
            alert('Something went wrong. Please try again later.');
            return;
        }

        // Send the Google tracking data
        TagManager.dataLayer({
            dataLayer: {
                event: 'sp-labs-contact',
            }
        });

        setShowSuccessMessage(true)
        setEmail("")
        setCompanyName("")
        setMessage("")
    }

    useEffect(() => {
        if (email.length > 0 && companyName.length > 0 && message.length > 0) {
            const isValidEmail = verifyEmail(email);
            if (isValidEmail) {
                setButtonDisabled(false);
            } else {
                setButtonDisabled(true);
            }
        } else {
            setButtonDisabled(true);
        }
    }, [email, companyName, message])

    return (
        <CustomModal
            closeModal={closeModal}
            customModalContainerStyle={{ backgroundColor: "#ebebeb" }}
            customMainColStyle={{ paddingTop: "0px" }}>

            <div className="contact-us-modal-container">

                <div className="contact-us-form-row">
                    <div className="contact-us-form-col">
                        <p className="contact-us-input-header">Email address</p>
                        <TextField
                            placeholder='john@acme.inc'
                            type="email"
                            size="small"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            inputProps={{ style: { fontSize: "15px", fontWeight: 400, fontFamily: "Inter", paddingLeft: "15px", paddingRight: "10px", backgroundColor: "white" } }}
                        />
                    </div>
                </div>
                <div className="contact-us-form-row">
                    <div className="contact-us-form-col">
                        <p className="contact-us-input-header">Name</p>
                        <TextField
                            placeholder='John'
                            size="small"
                            type="text"
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            inputProps={{ style: { fontSize: "15px", fontWeight: 400, fontFamily: "Inter", paddingLeft: "15px", paddingRight: "10px", backgroundColor: "white" } }}
                        />
                    </div>
                    <div className="contact-us-form-col">
                        <p className="contact-us-input-header">Company name</p>
                        <TextField
                            placeholder="Acme Inc."
                            size="small"
                            type="text"
                            value={companyName}
                            onChange={(event) => setCompanyName(event.target.value)}
                            inputProps={{ style: { fontSize: "15px", fontWeight: 400, fontFamily: "Inter", paddingLeft: "15px", paddingRight: "10px", backgroundColor: "white" } }}
                        />
                    </div>
                </div>
                <div className="contact-us-form-row">
                    <div className="contact-us-form-col">
                        <p className="contact-us-input-header contact-us-input-header-bottom">Briefly describe your project.</p>
                        <CustomTextInput
                            placeholderText={"message"}
                            rows={3}
                            customTextAreaStyle={{ backgroundColor: "white", padding: "15px", borderRadius: "5px", border: "1px solid #bababa" }}
                            sendDataToParent={(data) => setMessage(data)}
                        />
                    </div>
                </div>

                <div className="contact-us-form-button-row">
                    <CustomButton onClick={() => submitForm()} buttonText="Contact" disabled={buttonDisabled} />
                </div>
                {showSuccessMessage &&
                    <div>
                        <p className="contact-us-success-message">
                            We've received your message and will be in contact shortly!
                        </p>
                    </div>
                }
            </div>

        </CustomModal >
    )

}

export default ContactUsModal;

/*
<ReCAPTCHA
                    sitekey={REACT_APP_CAPTCHA_KEY}
                    onChange={onChange}
                />
*/